<template>
	<div class="pb-20 md:flex">
		<div class="md:w-5/12 md:pr-20">
			<img
				v-if="featuredExpert.image"
				:src="featuredExpert.image"
				class="mb-10"
			/>
			<div class="px-8 md:px-0">
				<Score :percentage="percentage">{{ uiCopy.expertMatch }}</Score>
				<div class="hidden md:block" v-if="handPickCta">
					<p class="font-60 mb-2">{{ uiCopy.handPickBlurb }}</p>
					<a href="#additional-experts" class="link type-400 mb-10">{{
						uiCopy.handPick
					}}</a>
				</div>
			</div>
		</div>
		<div class="px-8 md:px-0 md:w-7/12">
			<hr class="border-mono-200 mb-10 md:hidden" />
			<p class="font-70 type-800 mb-1" v-if="featuredExpert.title">
				{{ featuredExpert.title }}
			</p>
			<p class="text-mono-500 mb-8" v-if="featuredExpert.role">
				{{ featuredExpert.role }}
			</p>
			<p class="mb-8" v-if="featuredExpert.blurb">
				{{ featuredExpert.blurb }}
			</p>
			<template v-if="featuredExpert.expertise">
				<p class="font-60 mb-2">{{ uiCopy.expertise }}</p>
				<p class="mb-8">
					{{ featuredExpert.expertise }}
				</p>
			</template>
			<template v-if="featuredExpert.specialties.length">
				<p class="font-60 mb-2">{{ uiCopy.specialties }}</p>
				<div class="mb-10 list-styling">
					<ul>
						<li
							v-for="(item, index) in featuredExpert.specialties"
							:key="index"
						>
							{{ item.col1 }}
						</li>
					</ul>
				</div>
			</template>
			<RequestButton
				:expert="featuredExpert.title"
				:userEmail="userEmail"
				v-on:user-requested="userRequested"
				class="btn-primary w-full max-w-md"
				>{{ uiCopy.requestMeeting }}
				<span class="hidden md:inline"
					>{{ uiCopy.with }} {{ featuredExpert.title.split(' ')[0] }}</span
				>
			</RequestButton>
		</div>
	</div>
</template>

<script>
export default {
	data: function () {
		return {
			featuredExpert: null,
			percentage: null,
		}
	},
	props: {
		result: {
			type: Number,
			required: true,
		},
		questions: {
			type: Array,
			required: true,
		},
		userEmail: {
			type: String,
			required: true,
		},
		handPickCta: {
			type: Boolean,
			required: true,
		},
		uiCopy: {
			type: Object,
			required: true,
		},
	},
	created: function () {
		const match = this.questions.find((el) => el.id === this.result)
		this.featuredExpert = match.featuredExpert
		this.percentage = match.percentage
	},
	methods: {
		userRequested: function (data) {
			this.$emit('user-requested', data)
		},
	},
}
</script>
